<div class="container">
  <div class="container-padding">
    <h1 class="header m-0">{{ data?.attributeName }}</h1>
  </div>
  <div>
    <mat-tab-group animationDuration="0ms" class="mat-tab-body-content">
      <mat-tab label="About" *ngIf="data?.description">
        <section class="item-cover">
          <h4 class="mb-0">Description</h4>
          <span [innerHTML]="data?.description | safeHtml"></span>
        </section>
      </mat-tab>
      <mat-tab label="History" *ngIf="data?.type != 'EncryptedField'">
        <section class="item-cover">
          <field-data-historical-modal-modal [attributeName]="data?.attributeName" [id]="data?.id">
          </field-data-historical-modal-modal>
        </section>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class="container-padding">
    <button mat-raised-button color="primary" [mat-dialog-close]="true">Close</button>
  </div>
</div>
